/**
 * @format
 * @flow
 */
import axios from 'axios';
import * as Setting from '../constants/reducers/Setting';
import * as Api from '../constants/Api';
import { loadStart, loadEnd, modalOpen, modalClose } from './App';
import { getEnterpriseCategories } from '../db/categories';

export const modalCloseInAuth = () => {
  return dispatch => {
    dispatch(modalClose());
  };
};

export const getSetting = (enterpriseId, token, email) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.settingsApi,
        {
          code: 'get_profile',
          enterpriseId,
          email
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '取得エラー'));
        } else {
          dispatch(displaySetting(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(err => {
        dispatch(loadEnd());
      });
  };
};

export const displaySetting = data => {
  return {
    type: Setting.GET_SETTING,
    data
  };
};

export const updateSetting = (args, token) => {
  console.log('TCL: updateSetting -> args', args);
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.settingsApi, args, {
        headers: { Authorization: token }
      })
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('TCL: updateSetting -> res', res);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '取得エラー'));
        } else {
          localStorage.setItem('current_user', JSON.stringify(res.data.enterprise));
          dispatch(updateComplete(res.data));
          dispatch(modalOpen('設定更新が完了しました。'));
        }
        dispatch(loadEnd());
      })
      .catch(err => {
        dispatch(loadEnd());
      });
  };
};

export const updateComplete = data => {
  return {
    type: Setting.UPDATE_SETTING,
    data
  };
};

export const getEpCategories = token => {
  return dispatch => {
    dispatch(getEnterpriseCategories(token)).then(result => {
      dispatch(enterpriseCategorySave(result));
    });
  };
};
export const enterpriseCategorySave = data => {
  return {
    type: Setting.GET_ENTERPRISE_CATEGORIES,
    data
  };
};
